/** One row of the bank statements screen, as ListBankStatementDTO sends it. */
export interface ListBankStatement {
    id: number;
    reference: string;
    amount: number;
    currency: string;
    /** The bank's own label, e.g. "Получен превод в EUR". */
    paymentType: string;
    /** Payment details 1, 2 and 3 already joined by the backend. */
    paymentDetails: string;
    beneficiaryBankName: string;
    /** A BankStatementMatchStatus value - see MATCH_STATUSES below. */
    matchStatus: string;
    matchNote: string;
    /** The invoice numbers actually settled, comma separated; empty until something matches. */
    matchedInvoiceNumbers: string;
    /** Why the last matching attempt threw. Normally set only on a FAILED row. */
    matchErrorText: string;
    /** Consecutive failed attempts - how close the row is to being written off. */
    retryCount: number;
    transactionDate: string;
}

/** What one import run did, as the manual fetch button reports it. */
export interface BankStatementImportRun {
    /** False when an import was already running and this request did nothing. */
    started: boolean;
    fetched: number;
    stored: number;
    skipped: number;
    failed: number;
    /** Set only when the call to the bank itself failed. */
    errorText: string;
}

/** What one matching run did, as the manual match button reports it. */
export interface BankStatementMatchRun {
    /** False when a run was already in progress and this request did nothing. */
    started: boolean;
    considered: number;
    matched: number;
    unmatched: number;
    ambiguous: number;
    ignored: number;
    failed: number;
    /** Of the failures, how many will not be retried again. */
    writtenOff: number;
    /** True when the run filled its budget and left candidates it never reached. */
    reachedLimit: boolean;
}

/**
 * The match statuses the backend can report, in the order the filter offers them.
 * Kept in step with bg.infosys.digital.auto.db.enums.BankStatementMatchStatus.
 */
export const MATCH_STATUSES: string[] = [
    'PENDING',
    'MATCHED',
    'PARTIALLY_MATCHED',
    'UNMATCHED',
    'AMBIGUOUS',
    'IGNORED',
    // Written off after too many failed attempts. In the filter because the matcher no
    // longer touches these rows, so this is the only way an operator finds them.
    'FAILED'
];
